import { Routes } from '@angular/router';
import { apiConfigResolver } from '@df/api/config/api-config.resolver';
import { basketItemsStockReloadResolver } from '@df/basket/stock-reload.resolver';
import { SearchResolver } from '@df/search/search.resolver';
import { CustomerNotLoggedGuard } from '@df/session/customer/customer-not-logged.guard';
import { CustomerReloadResolver } from '@df/session/customer/customer-reload.resolver';
import { DevOnlyGuard } from '@df/ui/dev-only.guard';
import { PlainRouterOutletComponent } from '@df/util/plain-router-outlet.component';
import { AppRootComponent } from './app-root.component';
import { BasketViewCmsComponent } from './basket/view/basket-view-cms.component';
import { BasketViewCmsResolver } from './basket/view/basket-view-cms.resolver';
import { Error500Component } from './catalog/error/error-500.component';
import { SearchViewComponent } from './search/ui/search-view.component';
export const appRoutes: Routes = [
    {
        path: '_library',
        canActivate: [DevOnlyGuard],
        resolve: {
            appData: apiConfigResolver
        },
        loadChildren: () =>
            import(
                /* webpackChunkName: "dfd.aw" */
                './module/df-demo/dfd.module'
            ).then(m => m.DfdModule)
    },
    {
        path: '',
        component: AppRootComponent,
        children: [
            {
                path: 'account',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "account" */
                        './account/account.routes'
                    ).then(m => m.accountRoutes)
            },
            {
                path: 'login',
                canActivate: [CustomerNotLoggedGuard],
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "login.async" */
                        './login/login.routes'
                    ).then(m => m.loginRoutes)
            },
            {
                path: 'basket',
                component: BasketViewCmsComponent,
                resolve: {
                    customer: CustomerReloadResolver,
                    stock: basketItemsStockReloadResolver,
                    layout: BasketViewCmsResolver
                }
            },
            {
                path: 'checkout',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "checkout.async" */
                        './checkout/checkout.routes'
                    ).then(m => m.checkoutRoutes)
            },
            {
                path: 'sample-checkout',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "checkout" */
                        './samples-checkout/samples-checkout.module'
                    ).then(m => m.SamplesCheckoutModule)
            },
            {
                path: 'search',
                component: PlainRouterOutletComponent,
                children: [
                    {
                        path: '**',
                        component: SearchViewComponent,
                        resolve: {
                            searchResult: SearchResolver
                        }
                    }
                ]
            },
            // {
            //     path: 'newsletter/subscribe',
            //     component: NewsletterFormComponent
            // },
            // {
            //     path: 'newsletter/unsubscribe',
            //     component: NewsletterUnsubscribeComponent
            // },
            {
                path: 'error',
                component: Error500Component
            },
            {
                path: '**',
                pathMatch: 'full',
                loadChildren: () =>
                    import(
                        /* webpackChunkName: "catalog.async" */
                        './catalog/catalog.routes'
                    ).then(m => m.catalogRoutes)
            }
        ],
        // enableTracing: true,
        resolve: {
            appData: apiConfigResolver
        }
    }
];
